<ng-container *ngIf="!!communication">
  <div class="m-3">
    <!-- Title -->
    <div class="font-550 font-875-rem">
      {{ application.applicantDescription }}
    </div>
    <div class="mb-3">
      <yc-i18n
        [key]="!!application.nominee ? 'GLOBAL:textNominationID' : 'common:textApplicationId'"
        [defaultValue]="!!application.nominee ? 'Nomination ID' : 'Application ID'">            
      </yc-i18n>: {{ application.applicationId }}
    </div>

    <!-- Email Details -->
    <div class="font-550">
      <!-- Subject -->
      <div>
        <yc-i18n
          key="common:labelSubject"
          defaultValue="Subject">
        </yc-i18n>: {{ communication.subject }}
      </div>

      <!-- CC-->
      <small *ngIf="communication.ccEmails?.length > 0"
        class="d-block">
        <yc-i18n
          class="font-550"
          key="common:textCC"
          defaultValue="CC">
        </yc-i18n>: 
        {{ communication.ccEmails.join() }}
      </small>

      <!-- Attachments -->
      <small *ngIf="communication.emailAttachments?.length > 0"
        class="d-block">
        <yc-i18n
          class="font-550"
          key="common:textAttachments"
          defaultValue="Attachments">
        </yc-i18n>: 
        <div *ngFor="let attachment of communication.emailAttachments">
          <yc-fa
            icon="paperclip"
            [light]="true"
            class="me-2">
          </yc-fa>
          <ng-container *ngIf="!attachment.fileUploadId">
            {{ attachment.fileName }}
          </ng-container>
          <yc-button *ngIf="attachment.fileUploadId"
            [link]="true"
            (onClick)="downloadFile(attachment)"
            class="anchor-tag"
            target="_blank">
            {{ attachment.fileName }}
          </yc-button>
        </div>
      </small>
    </div>
  </div>

  <div class="rich-email-content"
    [innerHTML]="communication.body | escapeHtml">
  </div>  
</ng-container>